export default "__VITE_ASSET__e7898810__"